import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FileDetails, fileParms } from '@core/services/file-processing/file-processing.model';
import { FileProcessingService } from '@core/services/file-processing/file-processing.service';
import { MenuService } from '@core/services/menu/menu.service';
import { ExcelServicesService } from '@core/services/report/excel-services.service';
import { ReportService } from '@core/services/report/report.service';
import { ReportQueryModel, ReportViewModel } from '@core/services/report/report-view-model';
import { Hash } from '@core/services/client/client.model';
import { ClientService } from '@core/services/client/client.service';
import { process } from '@progress/kendo-data-query';
import { GridSettings } from '@shared/components/customized-grid/grid-settings/gird-settings.interface';
import * as FileSaver from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { now } from 'moment';
import { LocalStorageService } from '../../core/services/local-storage/local-storage.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'Teranet-DownloadReport',
  templateUrl: './download-report.component.html'
})
export class DownloadReportComponent implements OnInit {
  clientInfoId: number;
  clientinfos: Hash[] = [];
  fileParms: fileParms;
  downloadFileName: string = '';
  fileList: FileDetails[] = [];
  gridSettings: GridSettings;
  hideMessage: boolean;
  isHideGrid: boolean = true;
  message: string = '';
  reportCriteriaModel: ReportQueryModel;
  reportDates: any[];
  reportForm: FormGroup;
  reportList: ReportViewModel[] = [];
  reportTypes: any[];
  selectedReportType: any;
  services: any;

  constructor(
    private datePipe: DatePipe,
    private fileProcessingService: FileProcessingService,
    private excelService: ExcelServicesService,
    private menuSerivce: MenuService,
    private reportService: ReportService,
    private spinner: NgxSpinnerService,
    private clientService: ClientService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService
  ) {
    this.reportForm = new FormGroup({
      genericReportType: new FormControl('', Validators.required),
      reportFromDate: new FormControl(new Date(), Validators.required),
      reportToDate: new FormControl(new Date(), Validators.required),
    });
    this.reportCriteriaModel = new ReportQueryModel();

    this.clientInfoId = this.localStorageService.getItem('currentUser')
      ? this.localStorageService.getItem('currentUser').corporationid >= 0
        ? this.localStorageService.getItem('currentUser').corporationid
        : -1
      : -1;
    if (this.clientInfoId == -1) {
      this.toastrService.error('There is problem with your login, please logout and try again.');
      return;
    }
  }

  public state: any = {
    skip: 0,
    take: 13,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  ngOnInit(): void {
    this.isHideGrid = true;
    this.BindClientInfos();
    this.reportCriteriaModel.clientId = this.clientInfoId;
    this.BindReportTypes();
    this.gridSettings = this.GridDefaultSettings();
  }

  BindClientInfos() {
    this.clientService.getClientInfoHash().subscribe(data => {
      this.clientinfos = data as Hash[];
      // Default the Corporation Selection
      if (this.clientinfos.length == 1 && this.clientinfos[0].id != undefined) {
        //this.reportForm.get('client').setValue(this.clientinfos[0].id);
        //this.BindReportDates();
      }
    });
  }



  BindReportTypes() {
    this.isHideGrid = true;
    this.reportTypes = [];
    this.fileList = [];
    this.reportService.GetReportNames().subscribe(data =>
      this.menuSerivce.GetSubPages('Report').subscribe(x => {
        for (let item in x) {
          let key = data.find(r => r.reportName == x[item].displayName);
          if (
            key !== undefined &&
            this.reportTypes.filter(r => r.value == key.reportId) != undefined &&
            this.reportTypes.filter(r => r.value == key.reportId).length == 0
          ) {
            this.reportTypes.push({
              label: key.reportLabel,
              value: key.reportId,
              text: key.reportName,
              isFileDocument: key.isFileDocument,
            });
          }
        }
      })
    );
  }
   

  downloadFile(row: any, services: any) {
    if (row && this.services) {
      let fileProcessingService =
        this.services && this.services[0]
          ? this.services[0]
          : this != null
            ? this.fileProcessingService
            : null;
      let spinner =
        this.services && this.services[1] ? this.services[1] : this != null ? this.spinner : null;

      if (spinner) {
        spinner.show();
      }
      this.downloadFileName = row.documentDescription;
      if (fileProcessingService) {
        fileProcessingService.downloadFile(row.documentId).subscribe(response => {
          if (response) {
            const blob = new Blob([response.body], { type: response.headers.get('content-type') });
            this.downloadFileName =
              this.downloadFileName || response.headers.get('content-disposition').split(';')[0];
            const file = new File([blob], this.downloadFileName, {
              type: response.headers.get('content-type'),
            });
            FileSaver.saveAs(file);
          }
          if (spinner) {
            spinner.hide();
          }
        });
      } else {
        if (spinner) {
          spinner.hide();
        }
      }
    }
  }

  getFileListRefresh() {
    setTimeout(() => {
      if (this.fileList != null && this.fileList.length >= 0) {
        this.spinner.hide();
      } else {
        this.getFileListRefresh();
      }
    }, 500);
  }

  getFiles() {
    this.fileParms = {
      clientInfoId: this.reportForm.get('client').value,
      fileTypeId: 1,
      files: [],
      infoId: this.reportForm.get('genericReportType').value,
      type: 2,
      startTime: new Date(parseInt(this.datePipe.transform(this.reportCriteriaModel.reportFromDate, 'yyyy')), parseInt(this.datePipe.transform(this.reportCriteriaModel.reportFromDate, 'MM')) - 1, 1, 0, 0, 0),
      endTime: new Date(parseInt(this.datePipe.transform(this.reportCriteriaModel.reportToDate, 'yyyy')), parseInt(this.datePipe.transform(this.reportCriteriaModel.reportToDate, 'MM')), 0, 23, 59, 59)
    };
    this.fileProcessingService.getAllFiles(this.fileParms).subscribe(data => {
      if (data) {
        this.fileList = data;
      }
      this.isHideGrid = false;
    });
  }

  BindReportDates() {
    if (this.reportCriteriaModel.reportType != null && this.reportCriteriaModel.clientId != null) {
      this.isHideGrid = true;
      this.reportDates = [];
      this.fileList = [];
      this.selectedReportType = this.reportTypes.find(
        r => r.value == this.reportCriteriaModel.reportType
      );
    }
  }

  submit() {
    this.message = '';
    if (this.reportCriteriaModel.reportType != null && this.reportCriteriaModel.clientId != null) {
      if (this.selectedReportType != null && this.selectedReportType != undefined) {
        if (this.selectedReportType.isFileDocument) {
          this.spinner.show();
          this.fileList = [];
          this.getFiles();
          this.getFileListRefresh();
        } else {
          let reportModel: ReportQueryModel = {
            clientId: this.reportCriteriaModel.clientId,
            reportType: this.selectedReportType.label,
            reportFromDate: this.reportForm.get("reportFromDate").value,
            reportToDate: this.reportForm.get("reportToDate").value,
          };
          this.reportService.GetReport(reportModel).subscribe(
            x => {
              const reportdate = {
                DateFrom: reportModel.reportFromDate,
                DateTo: reportModel.reportToDate,
                Client: this.clientinfos.find(x => x.id == this.reportCriteriaModel.clientId)
                  .description,
                CreatedOn: now(),
              };
              if (x['result'] != null && x['result']['totalRecords'] != 0)
              {
                this.excelService.exportPortalFile(x['result'], this.selectedReportType.text, reportdate);
                this.hideMessage = false;
                this.message = 'Report download completed.';

              }
              else
              {
                this.hideMessage = false;
                this.message = 'No Report during this period.';

              }

              //this.excelService.exportAsExcelFile(
              //  x['result']['data'],
                //JSON.parse(x.xmlData)[this.selectedReportType.label]['row'],
              //  this.selectedReportType.text,
              //  reportdate
              //);
            },
            (err: HttpErrorResponse) => {
              this.hideMessage = true;
              this.message = err.error;
            }
          );
        }
      }
    }
  }

  reset() {
    this.isHideGrid = true;
    this.message = '';
    this.fileList = [];
    this.reportForm.reset();
  }

  GridDefaultSettings(): GridSettings {
    return {
      state: this.state,
      gridData: process(this.fileList, this.state),
      columnsConfig: [
        {
          field: 'documentDescription',
          filterable: true,
          includeInChooser: false,
          hidden: false,
          title: 'Report Name',
          width: 250,
        },
        {
          field: 'documentCreatedDateUtc',
          filter: 'date',
          filterable: true,
          format: 'yyyy-MM-dd HH:mm:ss',
          hidden: false,
          title: 'Created Date Time',
          type: 'dateUTC',
          width: 200,
        },
        {
          clickAction: this.downloadFile,
          field: 'documentId',
          filterable: false,
          hidden: false,
          icon: 'download',
          includeInChooser: false,
          title: 'Download',
          type: 'icon',
          services: [this.fileProcessingService, this.spinner],
          width: 80,
        },
      ],
    };
  }
}
